module.exports = __webpack_public_path__ + "static/image3-3aba0f8e35c003a59343fee719e778c1.jpeg";